// src/features/auth/route-protection/guards/AuthGuard.tsx
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/app/hooks';
import { LoadingScreen } from '@/features/shared/components/ui/LoadingScreen';

export const AuthGuard: React.FC = () => {
  const location = useLocation();
  const { isAuthenticated, isLoading, isInitialized, user } = useAppSelector(state => state.auth);

  // Show loading screen while checking auth status
  if (!isInitialized || isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if email is verified (optional) - skip for now to avoid loops
  // if (user && !user.emailVerified) {
  //   return <Navigate to="/verify-email" replace />;
  // }

  // Check if user needs to complete onboarding (optional) - skip for now
  // if (user && !user.onboardingCompleted && location.pathname !== '/onboarding') {
  //   return <Navigate to="/onboarding" replace />;
  // }

  // Render child routes
  return <Outlet />;
};

export default AuthGuard;